import Causes1 from "assets/images/causes/causes-1.png";
import Causes2 from "assets/images/causes/causes-2.png";
import Causes3 from "assets/images/causes/causes-3.png";
import Causes4 from "assets/images/causes/causes-4.png";
import Causes5 from "assets/images/causes/causes-5.png";
import Causes6 from "assets/images/causes/foster_kinship_main.jpg";
import Causes7 from "assets/images/causes/flags_freedom1.png";
import Causes43 from 'assets/images/causes/causes-43.png';
import Causes44 from 'assets/images/causes/causes-44.png';
import Causes45 from "assets/images/causes/causes-4.png";
import Causes46 from "assets/images/causes/Group254.png";

import food from "assets/images/causes/food.png";
import fight from "assets/images/causes/fight.png";
import support from "assets/images/causes/support.png";
import protect from "assets/images/causes/protect.png";

import causesIcon1 from "assets/icons/causes/causes-blue-icon1.png";
import causesIcon2 from "assets/icons/causes/causes-blue-icon2.png";
import causesIcon3 from "assets/icons/causes/causes-blue-icon3.png";
import causesIcon4 from "assets/icons/causes/causes-blue-icon4.png";

export default [
  {
    id: 2,
    image: Causes1,
    symbol: food,
    icon: causesIcon1,
    shortTitle: "Fighting Food Insecurity",
    title: "Feeding Children & Fighting Food Insecurity",
    description:
      "Food insecurity affects hundreds of millions of people worldwide. Even in America 1 in 7 people struggle to put food on their table, with families with children being the most likely to experience hunger.  The Zwagil Foundation is dedicated to making sure that children and families never go hungry.",
    long_description:
      "One thing we love about water.org:  Small loan program.  Millions of people around the world could get access to safe water in their homes with the help of small, affordable loans. That's where water.org comes in. There is both a need and demand for these loans, because when people have access to safe water, they get time back to go to school, earn an income and take care of their family. It changes their world. For 30 years, water.org has been providing families with hope, health and the opportunity to break the cycle of poverty.",
    website_url: "https://ourrescue.org/",
    thumnails: "",
    partner_ids: [2, 5],
  },
  {
    id: 1,
    image: Causes2,
    symbol: fight,
    icon: causesIcon2,
    shortTitle: "Fighting Human Trafficking",
    title: "Fighting Human Trafficking",
    description:
      "Every year millions of vulnerable people, mostly women and children, are sexually exploited and trafficked. Our Partners are leading the charge to end human trafficking by rescuing victims, assisting law enforcement in the capture and prosecution of the traffickers and empowering survivors to regain their dignity on a path to a full, vibrant life.  Join us in supporting our Partners in this critical life or death fight against the horrors of human trafficking.",
    long_description:
      "Food insecurity affects hundreds of millions of people worldwide. Even in America 1 in 7 people struggle to put food on their table, with families with children being the most likely to experience hunger.  The Zwagil Foundation is dedicated to making sure that children and families never go hungry.",
    website_url: "https://www.threesquare.org/",
    thumnails: "",
    partner_ids: [1, 3],
  },
  {
    id: 3,
    image: Causes3,
    symbol: support,
    icon: causesIcon3,
    shortTitle: "Supporting Veterans",
    title: "Supporting Veterans",
    description:
      "Many Veterans face significant challenges following their service and as they transition to civilian life. Often these include struggles with service related mental health issues, coping with physical injuries, or finding a job and earning a living.  We extend our heartfelt appreciation to our Veterans for their service and are honored to partner with organizations that support the needs and enrich the lives of those heroes and their families.",
    long_description:
      "Many Veterans face significant challenges following their service and as they transition to civilian life. Often these include struggles with service related mental health issues, coping with physical injuries, or finding a job and earning a living.  We extend our heartfelt appreciation to our Veterans for their service and are honored to partner with organizations that support the needs and enrich the lives of those heroes and their families.",
    website_url: "https://www.thorn.org/",
    thumnails: "",
    partner_ids: [],
  },
  {
    id: 4,
    image: Causes4,
    symbol: protect,
    icon: causesIcon4,
    shortTitle: "Protecting The Environment",
    title: "Protecting The Environment",
    description:
      "Protecting our world for a better today and for a brighter future for our children. Join us in supporting organizations that are leading the way in creating lasting solutions to some of the biggest environmental challenges and in supporting local farmers in the proliferation of sustainable and organic growing practices to protect the independence of these important growers while safeguarding our food system.",
    long_description:
      "Protecting our world for a better today and for a brighter future for our children. Join us in supporting organizations that are leading the way in creating lasting solutions to some of the biggest environmental challenges and in supporting local farmers in the proliferation of sustainable and organic growing practices to protect the independence of these important growers while safeguarding our food system.",
    website_url: "https://water.org/",
    thumnails: "",
    partner_ids: [4],
  },
  {
    id: 39,
    image: Causes5,
    symbol: '',
    icon: '',
    shortTitle: "Hurricane Ida Relief",
    title: "Hurricane Ida Relief",
    description:
      "Zwagil Foundation Emergency Relief is stepping up once again and we need your help to support the people of the Gulf region. With millions of people affected, many of whom are without power, access to drinking water, food, and basic necessities, we are amassing critical supplies to quickly send to the region.",
    long_description:
      "Zwagil Foundation Emergency Relief is stepping up once again and we need your help to support the people of the Gulf region. This time, we are on our way to Louisiana. Hurricane Ida left a humanitarian crisis in its wake.  There has been an almost complete loss of services to the region, including catastrophic damage to the power grid. Millions of people are without power and basic services, including water, sanitation and cell service. A vast number of people have been left homeless and many more can't access their homes. \n\nOur friends at Feeding Louisiana, Second Harvest Food Bank, and World Central Kitchen are on the ground tirelessly providing around the clock critical services and feeding tens of thousands affected by the storm.  For our part, Casey is loading up the Hempworx truck to the MAX with water, food and supplies bound for the Gulf region.  And we are sourcing a refrigeration trailer so that our partner, World Central Kitchen, can continue operating at full capacity at its emergency relief hub in New Orleans.\n\nTogether, we can change the World!",
    website_url: "",
    thumnails: "",
    partner_ids: [4],
  },
  {
    id: 41,
    image: Causes6,
    symbol: '',
    icon: '',
    shortTitle: "Holiday Toys Drive",
    title: "Holiday Toys Drive",
    description:
      "Each year, we love to shop for toys, bikes, and more, load up the truck and bring them to kids in need at Foster Kinship.\nThis holiday season, partner with the Zwagil Foundation in bringing smiles and joy to nearly a thousand foster children. \nLet's make this holiday a year to remember!\nEvery dollar donated is matched to reach more kids for the holidays. Your donation will let each child know that they are valued, loved and not forgotten.",
    long_description:
      "Each year, we love to shop for toys, bikes, and more, load up the truck and bring them to kids in need at Foster Kinship.\nThis holiday season, partner with the Zwagil Foundation in bringing smiles and joy to nearly a thousand foster children. \nLet's make this holiday a year to remember!\nEvery dollar donated is matched to reach more kids for the holidays. Your donation will let each child know that they are valued, loved and not forgotten.",
    website_url: "",
    thumnails: "",
    partner_ids: [],
  },
  // {
  //   id: 42,
  //   image: Causes7,
  //   symbol: '',
  //   icon: '',
  //   shortTitle: "Flags For Freedom",
  //   title: "Flags For Freedom",
  //   description:
  //     "<p>Want to stand-up for freedom and liberty, but not sure how to help?</p><p>The Zwagil Foundation is donating hundreds of US & Canadian Flags to Truckers, Veterans and those who stand for freedom.  Beginning Feb 23rd in Barstow, CA, Truckers participating in the People’s Convoy will be given Flags at no cost to fly on their trucks.</p><span><strong>You can show your support:</strong><br /></span><span>Spread Awareness . . . Post “What Freedom Means to Me” and use #FlagsForFreedom and Tag @zwagilfoundation</span><br /><span>Every $20 donated secures another Flag for Freedom</span>",
  //   long_description:
  //     "Want to stand-up for freedom and liberty, but not sure how to help?\nThe Zwagil Foundation is donating hundreds of US & Canadian Flags to Truckers, Veterans and those who stand for freedom.  Beginning Feb 23rd in Barstow, CA, Truckers participating in the People’s Convoy will be given Flags at no cost to fly on their trucks.\nYou can show your support:\nSpread Awareness . . . Post “What Freedom Means to Me” and use #FlagsForFreedom and Tag @zwagilfoundation\nEvery $20 donated secures another Flag for Freedom",
  //   website_url: "",
  //   thumnails: "",
  //   partner_ids: [],
  // },
  {
    id: 43,
    image: Causes43,
    symbol: '',
    icon: '',
    shortTitle: "Holidays with Children",
    title: "Holidays with Children",
    description:
      "Sharing the Joy and Spirit of the Holidays with Children in need And those families impacted by Hurrican Ian",
    long_description:
      "Sharing the Joy and Spirit of the Holidays with Children in need And those families impacted by Hurrican Ian",
    website_url: "",
    thumnails: "",
    partner_ids: [],
  },
  {
    id: 44,
    image: Causes44,
    symbol: '',
    icon: '',
    shortTitle: "Game On - Super Bowl Squares Fundraiser",
    title: "Game On - Super Bowl Squares Fundraiser",
    description:
      "IT'S GAME ON AT THE MDC DALLAS BOOTCAMP! PLAY SUPER BOWL SQUARES",
    long_description:
      "IT'S GAME ON AT THE MDC DALLAS BOOTCAMP! PLAY SUPER BOWL SQUARES",
    website_url: "",
    thumnails: "",
    partner_ids: [],
  },
  {
    id: 45,
    image: Causes45,
    symbol: '',
    icon: '',
    shortTitle: "Earth Day Children's Initiative",
    title: "Earth Day Children's Initiative",
    description:
      "Earth Day Children's Initiative",
    long_description:
      "Earth Day Children's Initiative",
    website_url: "",
    thumnails: "",
    partner_ids: [],
  },
  {
    id: 46,
    image: Causes46,
    symbol: '',
    icon: '',
    shortTitle: "Nashville - Children's Playground",
    title: "Nashville - Children's Playground",
    description:
      "Nashville - Children's Playground",
    long_description:
      "Nashville - Children's Playground",
    website_url: "",
    thumnails: "",
    partner_ids: [],
  },
];
